import { ContainerModule, type ContainerModuleLoadOptions } from 'inversify';
import { CurrentClientUserDependencyTypes } from '@client/entity/current-client-user/current-client-user.dependency-types';
import { CurrentClientUserApiService } from '@client/entity/current-client-user/data/service/current-client-user.api-service';
import { CurrentClientUserRepository } from '@client/entity/current-client-user/data/repository/current-client-user.repository';
import { CurrentClientUserService } from '@client/entity/current-client-user/domain/service/current-client-user.service';
import { CurrentClientUserApiDataTransformer } from '@client/entity/current-client-user/data/transformer/current-client-user.api-data-transformer';
import { CurrentClientUserClientApiDataTransformer } from '@client/entity/current-client-user/data/transformer/current-client-user-client.api-data-transformer';
import type { CurrentClientUserStoreQuery } from '@client/entity/current-client-user/domain/store/current-client-user.store-query';
import type { CurrentClientUserStoreCommand } from '@client/entity/current-client-user/domain/store/current-client-user.store-command';
import { CurrentClientUserPiniaStoreAdapter } from '@client/entity/current-client-user/application/store/current-client-user-pinia.store-adapter';
import { CurrentUserDependencyTypes } from '@shared/entity/current-user/current-user.dependency-types';
import type { CurrentUserStoreResetter } from '@shared/entity/current-user/domain/service/current-user-store-resetter.service';
import { CurrentUserApiDataTransformer } from '@shared/entity/current-user/data/transformer/current-user.api-data-transformer';
import { CurrentClientUserSelectedClientGamesReloaderService } from '@client/entity/current-client-user/domain/service/current-client-user-selected-client-games-reloader.service';
import { CurrentClientUserSelectionService } from '@client/entity/current-client-user/domain/service/current-client-user-selection.service';
import { CurrentClientUserSelectedClientService } from '@client/entity/current-client-user/domain/service/current-client-user-selected-client.service';
import type { CurrentClientUserSelectionRepositoryInterface } from '@client/entity/current-client-user/domain/repository/current-client-user-selection.repository';
import { CurrentClientUserSelectionLocalStorageService } from '@client/entity/current-client-user/data/service/current-client-user-selection.local-storage-service';
import { CurrentClientUserSelectionRepository } from '@client/entity/current-client-user/data/repository/current-client-user-selection.repository';

export const currentClientUserContainerModule = new ContainerModule((options: ContainerModuleLoadOptions) => {
  options
    .bind<CurrentClientUserApiService>(CurrentClientUserDependencyTypes.CurrentClientUserApiService)
    .to(CurrentClientUserApiService)
    .inSingletonScope();
  options
    .bind<CurrentClientUserRepository>(CurrentClientUserDependencyTypes.CurrentClientUserRepository)
    .to(CurrentClientUserRepository)
    .inSingletonScope();
  options
    .bind<CurrentClientUserService>(CurrentClientUserDependencyTypes.CurrentClientUserService)
    .to(CurrentClientUserService)
    .inSingletonScope();
  options
    .bind<CurrentClientUserStoreQuery>(CurrentClientUserDependencyTypes.CurrentClientUserStoreQuery)
    .to(CurrentClientUserPiniaStoreAdapter);
  options
    .bind<CurrentClientUserStoreCommand>(CurrentClientUserDependencyTypes.CurrentClientUserStoreCommand)
    .to(CurrentClientUserPiniaStoreAdapter);
  options
    .bind<CurrentClientUserSelectedClientGamesReloaderService>(
      CurrentClientUserDependencyTypes.CurrentClientUserSelectedClientGamesReloaderService,
    )
    .to(CurrentClientUserSelectedClientGamesReloaderService)
    .inSingletonScope();
  options
    .bind<CurrentClientUserSelectionService>(CurrentClientUserDependencyTypes.CurrentClientUserSelectionService)
    .to(CurrentClientUserSelectionService);
  options
    .bind<CurrentClientUserSelectionLocalStorageService>(
      CurrentClientUserDependencyTypes.CurrentClientUserSelectionLocalStorageService,
    )
    .to(CurrentClientUserSelectionLocalStorageService);
  options
    .bind<CurrentClientUserSelectionRepositoryInterface>(
      CurrentClientUserDependencyTypes.CurrentClientUserSelectionRepository,
    )
    .to(CurrentClientUserSelectionRepository);
  options
    .bind<CurrentClientUserSelectedClientService>(
      CurrentClientUserDependencyTypes.CurrentClientUserSelectedClientService,
    )
    .to(CurrentClientUserSelectedClientService);
  options
    .bind<CurrentUserStoreResetter>(CurrentUserDependencyTypes.StoreResetter)
    .to(CurrentClientUserPiniaStoreAdapter);
  if (!options.isBound(CurrentUserDependencyTypes.CurrentUserApiDataTransformer)) {
    options
      .bind<CurrentUserApiDataTransformer>(CurrentUserDependencyTypes.CurrentUserApiDataTransformer)
      .to(CurrentUserApiDataTransformer);
  }
  options
    .bind<CurrentClientUserApiDataTransformer>(CurrentClientUserDependencyTypes.CurrentClientUserApiDataTransformer)
    .to(CurrentClientUserApiDataTransformer);
  options
    .bind<CurrentClientUserClientApiDataTransformer>(
      CurrentClientUserDependencyTypes.CurrentClientUserClientApiDataTransformer,
    )
    .to(CurrentClientUserClientApiDataTransformer);
});
